import React from 'react'

import {
  Tabs, Icon, Chat, LikeDislikeIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

const tabs = [
  {
    id: 'comment',
    title: 'Comment',
    leadIcon: <Icon svgComponent={Chat} />,
  },
  {
    id: 'review',
    title: 'Review',
    leadIcon: <Icon svgComponent={LikeDislikeIcon} />,
  },
]

function ReviewTabs({ activeTab, onTabChange: handleTabChange }) {
  return (
    <Tabs
      className="review-sidebar__tabs"
      activeTabId={activeTab}
      onClick={handleTabChange}
      tabs={tabs}
    />
  )
}

ReviewTabs.propTypes = {
  activeTab: string.isRequired,
  onTabChange: func.isRequired,
}

export default ReviewTabs
